import script from "./UserCounselling.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCounselling.vue?vue&type=script&setup=true&lang=js"

import "./UserCounselling.vue?vue&type=style&index=0&id=176a4cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-176a4cb2"]])

export default __exports__